import verticalDetailsSymbols from "../symbols/verticalDetails";
import {
  HttpRegularDelete,
  HttpRegularPut,
  HttpRequestGet,
} from "../../service";
const verticalDetailsSymbolsAction = () => ({
  type: verticalDetailsSymbols.GET_VERTICAL_DETAILS,
});
const verticalDetailsSymbolsSuccessAction = (data: any) => ({
  type: verticalDetailsSymbols.GET_VERTICAL_DETAILS_SUCCESS,
  payload: data,
});
const verticalDetailsSymbolsFailureAction = (data: any) => ({
  type: verticalDetailsSymbols.GET_VERTICAL_DETAILS_FAILURE,
  payload: data,
});
const clearVerticalDetailsSymbolsAction = () => ({
  type: verticalDetailsSymbols.CLEAR_GET_VERTICAL_DETAILS,
});
const verticalRemovedSuccess = (data: any) => ({
  type: "VERTICAL_REMOVED_SUCCESS",
});
const verticalRemovedFailed = (data: any) => ({
  type: "VERTICAL_REMOVED_Failed",
});
export function getVerticalDetailsSymbols(id: string) {
  return (dispatch: any) => {
    dispatch(verticalDetailsSymbolsAction());
    HttpRequestGet(
      "/upc/vertical/" + id,
      dispatch,
      verticalDetailsSymbolsSuccessAction,
      verticalDetailsSymbolsFailureAction,
      true
    );
  };
}

export function updateVerticalDetails(
  id: string,
  body: any,
  failAction?: any,
  callback?: any
) {
  return (dispatch: any) => {
    HttpRegularPut("/upc/vertical/" + id, body, {
      dispatch: dispatch,
      actionSuccess: getVerticalDetailsSymbols,
      actionFailure: failAction,
      callback: callback,
    });
  };
}

export function removeVerticalDetails(
  id: string,
  failAction?: any,
  callback?: any
) {
  return (dispatch: any) => {
    HttpRegularDelete("/upc/vertical/" + id, {
      dispatch: dispatch,
      actionSuccess: verticalRemovedSuccess,
      actionFailure: verticalRemovedFailed,
      callback: callback,
    });
  };
}

export function clearVerticalsSymbols() {
  return (dispatch: any) => {
    dispatch(clearVerticalDetailsSymbolsAction());
  };
}
